import {
	ALERTS_ACTION_TYPES,
	AlertsAction,
	AlertsState,
} from '../../../types/alert'

const initialState: AlertsState = {
	filters: [],
	list: [],
	selected: [],
	searchValue: '',
}

export default (
	state: AlertsState = initialState,
	action: AlertsAction
): AlertsState => {
	switch (action.type) {
		case ALERTS_ACTION_TYPES.GET: {
			return {
				...initialState,
				list: action.payload,
			}
		}

		case ALERTS_ACTION_TYPES.SELECT: {
			const newSelectedAlertsArray = [...state.selected, action.payload]

			return {
				...state,
				selected: newSelectedAlertsArray,
			}
		}

		case ALERTS_ACTION_TYPES.DESELECT: {
			const newSelectedAlertsArray = state.selected.filter(
				alertId => alertId !== action.payload
			)

			return { ...state, selected: newSelectedAlertsArray }
		}

		case ALERTS_ACTION_TYPES.SELECT_ALL: {
			const allAlertsIds = state.list.map(alert => alert._id)

			return {
				...state,
				selected: allAlertsIds,
			}
		}

		case ALERTS_ACTION_TYPES.DESELECT_ALL: {
			return {
				...state,
				selected: [],
			}
		}
		case ALERTS_ACTION_TYPES.APPLY_FILTERS: {
			return {
				...state,
				filters: action.payload,
			}
		}
		case ALERTS_ACTION_TYPES.REMOVE_FILTER: {
			const updFilters = state.filters.filter(
				item => item.key !== action.payload
			)

			return {
				...state,
				filters: updFilters,
			}
		}
		case ALERTS_ACTION_TYPES.REMOVE_ALL_FILTERS: {
			return {
				...state,
				filters: [],
			}
		}
		case ALERTS_ACTION_TYPES.SET_SEARCH_VALUE: {
			return {
				...state,
				searchValue: action.payload,
			}
		}
		case ALERTS_ACTION_TYPES.RESET_ALERTS: {
			return initialState
		}
		case ALERTS_ACTION_TYPES.REMOVE_MANAGED: {
			const newAlertsList = state.list.filter(
				alert => !action.payload.includes(alert._id)
			)

			return {
				...state,
				list: newAlertsList,
				selected: [],
			}
		}
		default: {
			return state
		}
	}
}
